import API, { buildUrl, throwServiceError } from "./baseService";

const SEARCH_URI = "/search";

export const getSearch = async (params: { searchText: string }) => {
  try {
    const results = await API.get(buildUrl(SEARCH_URI, params));
    return results.data.searchListItems as SearchListItems[];
  } catch (error) {
    throwServiceError(error);
  }
};
